module.exports = __webpack_public_path__ + "img/b4.80b217c8.png";